import React from "react";

export default function MySQL_BIN() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MySQL_BIN</h1>
      <p>This is the MySQL_BIN component generated from the SQL JSON.</p>
    </div>
  );
}
